<template>
  <Card>
    <LocalDataTable :columns="columns" :ajax-link="ajaxLink"></LocalDataTable>
  </Card>
</template>

<script>
import {mapActions} from "vuex";
import Card from "@/components/forms/Card";
import LocalDataTable from "@/components/LocalDataTable";

export default {
name: "UserMessageList",
  components: {LocalDataTable, Card},
  data()
  {
    return{
      columns : [
        {title : 'موضوع'},
        {title : 'ارسال شده به'},
        {title : '<i class="far fa-cogs"></i>',sortable : false},
      ],
      ajaxLink: 'admin/Message/List',
    }
  },
  async mounted()
  {
    this.setPageLoading(false);
    this.setPageTitle('لیست پیام های ارسال شده');
    this.setShowHead(true);
  },
  methods: {
    ...mapActions('app', {
      setPageTitle: 'setPageTitle',
      setPageLoading: 'setPageLoading',
      setShowHead: 'setShowHead'
    }),
  }
}
</script>

<style scoped>

</style>